var containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  gap: '1rem'
};
var toggleStyles = {
  display: 'inline-block',
  width: '1.875rem',
  height: '.4375rem',
  bg: 'grey.200',
  border: "1px solid",
  borderColor: 'grey.300',
  borderRadius: '2px',
  _checked: {
    bg: 'blue.1160',
    borderColor: 'blue.1160'
  },
  _focus: {
    boxShadow: "0 0 0.1875rem 0.125rem #00CAFF",
    outline: 'none'
  }
};
var baseStyle = () => ({
  container: containerStyles,
  toggle: toggleStyles
});
export var Toggler = {
  baseStyle
};